'use client';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { LogoSliderBlock as ILogoSliderBlock } from '../types';
import Image from 'next/image';

export default function LogoSliderBlock({
  block,
}: {
  block: ILogoSliderBlock;
}) {
  const SWIPER_CONFIG = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 0 },
      320: { slidesPerView: 3, spaceBetween: 0 },
      480: { slidesPerView: 4, spaceBetween: 5 },
      768: { slidesPerView: 5, spaceBetween: 10 },
      1024: { slidesPerView: 6, spaceBetween: 15 },
      1280: { slidesPerView: 10, spaceBetween: 20 },
    },
  };

  return (
    <div className="border-graphite-100 border-b bg-white py-12">
      {block.title && (
        <div className="mb-10 flex items-center">
          <div className="bg-graphite-100 h-px flex-1" />
          <span className="text-blue-grey mx-6 text-sm font-semibold tracking-widest whitespace-nowrap uppercase">
            {block.title}
          </span>
          <div className="bg-graphite-100 h-px flex-1" />
        </div>
      )}

      <div className="relative w-full">
        {/* Logo Carousel */}
        <div className="w-full px-4">
          <Swiper
            modules={[Autoplay]}
            autoplay={SWIPER_CONFIG.autoplay}
            breakpoints={SWIPER_CONFIG.breakpoints}
            slidesPerView={10}
            spaceBetween={20}
            loop
            // Accessibility
            a11y={{
              enabled: true,
              prevSlideMessage: 'Previous logo',
              nextSlideMessage: 'Next logo',
            }}
          >
            {block.logos?.length > 0 ? (
              block.logos.map((logo, idx) => (
                <SwiperSlide key={logo.url + idx}>
                  <div className="flex items-center justify-center">
                    {logo.url && (
                      <Image
                        src={logo.url}
                        alt={logo.alt}
                        className="max-h-40 w-auto object-contain"
                        width={100}
                        height={100}
                        loading="lazy"
                        onError={event => {
                          event.currentTarget.style.display = 'none';
                        }}
                      />
                    )}
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <div className="text-center text-gray-500">
                No logos available
              </div>
            )}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
